module.exports = __webpack_public_path__ + "static/media/RA-AC0009S_02.bddd5218.png";